module.exports = __webpack_public_path__ + "static/kids-ministry-f89cc646d65de96115862c7bc0aac6f5.jpg";